



document.addEventListener('DOMContentLoaded', function(){
	console.log('<Temrin Header Package> has been initialized.');
	/*
		*	Store a reference to the header element.
	*/
	let header = document.querySelector('header');

	/*
		*	Define the amount of the pixel threshold.
	*/
	const SCROLL_THRESHOLD = 16; 

	/*
		*	Execute the checker function for once.
	*/
	check_Header();

	/*
		*	Assign an event listener for the scroll event to the header.
	*/
	window.addEventListener('scroll', check_Header);

	/* 	
		+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
	
		* [Function]	::: check_Header()
		*
		* @description	This function checks if the window is scrolled by the
						specified threshold amount, if so it changes the
						class attribute of the header element which changes
						header's background from transparent to the theme color.

		+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
	*/
	function check_Header(){

		let thresholdStatus = header.classList.contains("scroll-threshold-passed");
			// console.log("Threshold Status: \t" + thresholdStatus);

		/*
			*	Check if mobile menu is active.
		*/
		if(document.querySelector('.temrin-mobile-menu')){
			return false;
		}

		/*
			*	Check if threshold has not been passed.
		*/
		if(window.pageYOffset <= SCROLL_THRESHOLD){
			/*
				*	Check if header has the threshold class.
			*/
			if(thresholdStatus){
				header.classList.remove('scroll-threshold-passed');
			}
		}
		else{
			/*
				*	Check if the header does not have
			*/
			if(!thresholdStatus){
				header.classList.add('scroll-threshold-passed');
			}
		}
	}
});